import { Navigate } from "react-router-dom";
import { useParticipantAuth } from "@/context/ParticipantAuthContext";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Loader2 } from "lucide-react";

function FullscreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <Loader2 className="w-8 h-8 text-brand-accent animate-spin" />
    </div>
  );
}

export function ProtectedParticipantRoute({ children }) {
  const { participant, loading } = useParticipantAuth();
  if (loading) return <FullscreenLoader />;
  if (!participant) return <Navigate to="/login" replace />;
  return children;
}

export function ProtectedAdminRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) return <FullscreenLoader />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
